export default __webpack_public_path__ + "static/media/jetboat.a1e66496.svg";